export enum WaterOptions {
    UNKNOWN = 0,
    HAS_ANY = 1,
}
